import { imageAsset, link, videoAsset, richText } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  showFlags,
  items{
    american{
      mediaType,
      ${imageAsset.fragment('image')},
      ${imageAsset.fragment('flag')},
      imageSize,
      isImageRounded,
      altText,
      ${videoAsset.fragment('videoLoopDesktop')},
      ${videoAsset.fragment('videoLoopMobile')},
      title,
      description,
      ${richText.fragment('smallText')},
      ${link.fragment('cta1')},
      ${link.fragment('cta2')},
      ${link.fragment('cta3')}
    },
    canadian{
      mediaType,
      ${imageAsset.fragment('image')},
      ${imageAsset.fragment('flag')},
      imageSize,
      isImageRounded,
      altText,
      ${videoAsset.fragment('videoLoopDesktop')},
      ${videoAsset.fragment('videoLoopMobile')},
      title,
      description,
      ${richText.fragment('smallText')},
      ${link.fragment('cta1')},
      ${link.fragment('cta2')},
      ${link.fragment('cta3')}
    }
  }
`

export const fragment = (name = 'giftCards') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
